export default __webpack_public_path__ + "static/media/CafeNoire.f71cc0ae.jpeg";